<template>
  <div class="panel-group">
    <div class="panel-wrapper">
      <div class="panel-wrapper-header">
        <div class="panel-wrapper-header-tabs">
          <widgetTabs v-model="activeTab" :tabs="[
            {
              title: 'Inbox',
              value: 'inbox',
              icon: {
                inactive: require('@/assets/icons/inbox-gray.svg'),
                active: require('@/assets/icons/inbox-green.svg')
              }
            },
            {
              title: 'Sent',
              value: 'sentEmails',
              icon: {
                inactive: require('@/assets/icons/sent-email-gray.svg'),
                active: require('@/assets/icons/sent-email-green.svg')
              }
            }
          ]" @change="switchTab"></widgetTabs>
        </div>
      </div>
      <div class="panel-wrapper-body">
        <div class="panel-wrapper-body-container">
          <div class="sent-email-item" v-for="(item, index) in sentEmails" :key="index" @click="selectItem(item)"
            :class="{
              active:
                selected_item_details && item.id === selected_item_details.id,
            }">
            <div class="sent-email-item-header">
              <div class="sent-email-item-header-profile" v-if="item.name">
                <widgetProfile :title="item.name" :subtitle="''" :file_name="null" :path="$fullUrl('images/profiles/')"
                  :size="25" :text_size="11"></widgetProfile>
              </div>
              <div class="sent-email-item-header-title">{{ item.subject }}</div>
            </div>
            <div class="sent-email-item-body">
              <div class="sent-email-item-body-text">
                {{ htmlToText(item.message) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="email-draft-preview">
      <!-- Tab content details for email -->
      <div class="tab-content-details" v-show="selected_item_details">
        <div class="tab-content-details-header">
          <div class="tab-content-details-header-left-panel">
            <div class="email-info" v-if="selected_item_details">
              <h3 class="email-subject-preview">{{ selected_item_details.subject }}</h3>
              <p class="email-meta">
                <strong>From:</strong> {{ selected_item_details.from }}
              </p>
              <p class="email-meta" v-if="selected_item_details.to">
                <strong>To:</strong> {{ selected_item_details.to }}
              </p>
              <p class="email-meta">
                <strong>Date:</strong> {{ selected_item_details.date ? new
                  Date(selected_item_details.date).toLocaleString() : 'Invalid Date' }}
              </p>
            </div>
          </div>
          <div class="tab-content-details-options row" v-if="selected_item_details">
            <dropdown-menu>
              <ul>
                <li>
                  <app-dialog title="Delete Email" ask="Are you sure you want to delete this email?" yesText="Delete"
                    noText="Cancel" @onComfirm="deleteOutboxEmail(selected_item_details)">
                    <a>Delete Email</a>
                  </app-dialog>
                </li>
              </ul>
            </dropdown-menu>
          </div>
        </div>

        <div class="tab-content-details-body">
          <iframe ref="sentEmailBodyFrame" style="width: 100%; height: 100%; border: none;"></iframe>
        </div>

        <div class="tab-content-attachments"
          v-if="selected_item_details && selected_item_details.attachments && selected_item_details.attachments.length > 0">
          <h4>Attachments:</h4>
          <ul>
            <li v-for="(attachment, index) in selected_item_details.attachments" :key="index">
              {{ attachment.filename }} ({{ formatFileSize(attachment.size) }})
            </li>
          </ul>
        </div>
      </div>

      <!-- When no item selected -->
      <div class="widget-notfound" v-if="!selected_item_details">
        <widgetNotFoundWidget title="Select Email" content="Select email from the list to view information here"
          align="center">
          <img class="widget-img" src="@/assets/icons/select-item.svg" />
        </widgetNotFoundWidget>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  name: "",
  components: {},
  props: {
    phase: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      activeTab: 2,
      selected_item_details: null,
      sentEmails: [

      ],
      loading_page_data: false,
    };
  },
  mounted() {
    let vm = this;
    eventBus.$on("sentEmailReflesh", () => {
      vm.getOutboxEmailData();
    });
    vm.getOutboxEmailData();
  },
  computed: {},
  watch: {
    selected_item_details(newItem) {
      this.$nextTick(() => {
        const iframe = this.$refs.sentEmailBodyFrame;
        if (iframe) {
          if (newItem && newItem.message) {
            iframe.onload = () => {
              // Optional: If you need to manipulate the iframe's content after load.
              // const doc = iframe.contentWindow.document;
              // doc.body.style.margin = '10px'; // Example
            };
            iframe.srcdoc = newItem.message;
          } else {
            // Clear the iframe content if no item is selected or message is empty
            iframe.srcdoc = '<html><body style="background-color: #fafafa;"></body></html>';
          }
        } else {
          // Use the exact same warning as in InboxEmailPanel for consistency
          console.warn('SentEmailPanel: sentEmailBodyFrame ref not found during watch update.');
        }
      });
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.$emit("switchTab", tab.value);
    },
    selectItem(item) {
      let vm = this;
      vm.selected_item_details = item;
    },
    getOutboxEmailData() {
      let vm = this;
      vm.loading_page_data = true;
      console.log('[SentEmailPanel] Fetching sent emails for phase:', vm.phase);
      vm.$store
        .dispatch("EMAIL_GET_ALL_SENTMAIL", {
          phase: vm.phase,
        })
        .then((responce) => {
          vm.loading_page_data = false;
          console.log('[SentEmailPanel] Raw response from EMAIL_GET_ALL_SENTMAIL:', responce);

          // Adjust to access the nested data array for emails
          const emailData = responce && responce.data && responce.data.data;
          const pageToken = responce && responce.data && responce.data.pageToken;
          // Potential: vm.pageToken = pageToken; // If you implement pagination for sent items

          if (emailData) {
            console.log('[SentEmailPanel] Data to be formatted (actual email array):', emailData);
            if (!Array.isArray(emailData)) {
              console.error('[SentEmailPanel] Error: emailData is not an array! Received:', emailData);
              vm.sentEmails = [];
              vm.$notify({
                group: "status",
                title: "Error",
                text: "Received invalid data format for sent emails.",
                type: "error",
                duration: 5000,
              });
              return;
            }
            vm.sentEmails = vm.formattedEmail(emailData);
            console.log('[SentEmailPanel] Formatted sentEmails:', vm.sentEmails);
            if (vm.sentEmails.length === 0) {
              console.warn('[SentEmailPanel] No sent emails found after formatting.');
            }
          } else {
            console.error('[SentEmailPanel] Error: Email data (responce.data.data) is undefined or not in expected structure.', responce);
            vm.sentEmails = [];
          }
        })
        .catch((error) => {
          vm.loading_page_data = false;
          console.error("[SentEmailPanel] Error fetching or processing sent emails:", error);
          vm.sentEmails = []; // Clear emails on error
          vm.$notify({
            group: "status",
            title: "Error",
            text: "Could not load sent emails. Please try again.",
            type: "error",
            duration: 5000,
          });
        });
    },
    formattedEmail(data) {
      return data.map((item) => {
        const headers = item.payload.headers;
        const attachments = [];
        let message = '';
        let name = '';
        let messageType = '';

        const toHeader = headers.find(h => h.name === "To")?.value || "";
        const nameMatch = toHeader.match(/^"?([^"<]+)"?\s*<?.*>?$/);
        name = nameMatch ? nameMatch[1].trim() : toHeader;

        function findPart(parts, mimeType) {
          for (const part of parts) {
            if (part.mimeType === mimeType && part.body && part.body.data) {
              return atob(part.body.data.replace(/-/g, '+').replace(/_/g, '/'));
            }
            if (part.parts) {
              const nestedPartData = findPart(part.parts, mimeType);
              if (nestedPartData) return nestedPartData;
            }
          }
          return null;
        }

        function extractAttachments(partsArr) {
          if (!partsArr) return;
          partsArr.forEach(part => {
            if (part.filename && part.mimeType && !part.mimeType.startsWith('text/') && part.body && part.body.attachmentId) {
              attachments.push({
                filename: part.filename,
                mimeType: part.mimeType,
                attachmentId: part.body.attachmentId,
                size: part.body.size || 0
              });
            }
            if (part.parts) {
              extractAttachments(part.parts);
            }
          });
        }

        if (item.payload.parts) {
          message = findPart(item.payload.parts, 'text/html');
          messageType = message ? 'html' : '';
          if (!message) {
            message = findPart(item.payload.parts, 'text/plain');
            messageType = message ? 'plain' : '';
          }
          extractAttachments(item.payload.parts);
        } else if (item.payload.body && item.payload.body.data) {
          if (item.payload.mimeType === 'text/html') {
            message = atob(item.payload.body.data.replace(/-/g, '+').replace(/_/g, '/'));
            messageType = 'html';
          } else if (item.payload.mimeType === 'text/plain') {
            message = atob(item.payload.body.data.replace(/-/g, '+').replace(/_/g, '/'));
            messageType = 'plain';
          } else {
            message = atob(item.payload.body.data.replace(/-/g, '+').replace(/_/g, '/'));
            messageType = 'plain';
          }
        }

        if (message && messageType === 'plain') {
          message = message.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>');
        }

        if (!message) {
          message = item.snippet ? item.snippet.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>') : 'No content available.';
        }

        const formatted = {
          id: item.id,
          threadId: item.threadId,
          historyId: item.historyId,
          internalDate: item.internalDate,
          snippet: item.snippet,
          sizeEstimate: item.sizeEstimate,
          from: headers.find(h => h.name === "From")?.value || "",
          to: headers.find(h => h.name === "To")?.value || "",
          subject: headers.find(h => h.name === "Subject")?.value || "",
          date: headers.find(h => h.name === "Date")?.value || "",
          name: name,
          message: message,
          attachments: attachments,
          editing: false,
          loading: false
        };
        return formatted;
      });
    },
    formatFileSize(size) {
      if (size < 1024) {
        return size + ' B';
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB';
      } else if (size < 1024 * 1024 * 1024) {
        return (size / (1024 * 1024)).toFixed(2) + ' MB';
      } else {
        return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
      }
    },
    deleteOutboxEmail(item) {
      let vm = this;
      vm.$store
        .dispatch("PROCESSMESSAGE_EMAIL_OUTBOX_DELETE", { id: item.id })
        .then((responce) => {
          vm.selected_item_details = null;
          vm.getOutboxEmailData();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Email is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          item.loading = false;
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Something wrong while deleting email",
            type: "warn",
            duration: 3000,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.panel-group {
  width: 100%;
  display: flex;
  height: 100%;

  .panel-wrapper {
    width: 320px;
    height: 100%;

    .panel-wrapper-header {
      height: 50px;
      background: #ffffff;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;

      .panel-wrapper-header-tabs {
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0px 10px;
        width: 100%;
      }
    }

    .panel-wrapper-body {
      height: calc(100% - 50px);
      overflow-y: auto;
      border-bottom-left-radius: 7px;
      border-bottom-right-radius: 7px;

      .panel-wrapper-body-container {
        background: #ffffff;
        border-bottom-left-radius: 7px;
        border-bottom-right-radius: 7px;
        padding-bottom: 10px;

        .sent-email-item {
          padding: 6px 6px;
          transition: 0.3s ease-in-out;
          cursor: pointer;

          &:hover {
            background: #f4f4f4;
            box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
            transition: 0.1s ease-in-out;
          }

          &.active {
            background: #f4f4f4;
            transition: 0.1s ease-in-out;
          }

          .sent-email-item-header {
            display: flex;
            flex-direction: column;
            margin-bottom: 7px;

            .sent-email-item-header-profile {
              margin-right: 5px;
              margin-bottom: 10px;
            }

            .sent-email-item-header-title {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 700;
              font-size: 12px;
              line-height: 19px;
              color: #1c1c1c;
            }
          }

          .sent-email-item-body {
            .sent-email-item-body-text {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 400;
              font-size: 11px;
              color: #8e8b8b;
              overflow: hidden;
              display: block;
              max-height: 4rem;
              -webkit-line-clamp: 2;
              display: box;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              white-space: normal;
            }
          }
        }
      }
    }
  }

  .email-draft-preview {
    width: calc(100% - 320px);
    height: 100%;
    border-radius: 7px;
    margin-left: 5px;
    background-color: #fff;
    overflow-y: auto;

    .tab-content-details {
      width: 100%;
      min-height: 100%;
      border-radius: 5px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      padding: 15px;

      .tab-content-details-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding-bottom: 15px;
        border-bottom: 1px solid #eee;
        margin-bottom: 15px;

        .tab-content-details-header-left-panel {
          display: flex;
          align-items: flex-start;

          .email-info {
            display: flex;
            flex-direction: column;

            .email-subject-preview {
              font-family: "Nunito", sans-serif;
              font-size: 18px;
              font-weight: 700;
              color: #1c1c1c;
              margin: 0 0 8px 0;
            }

            .email-meta {
              font-family: "Nunito", sans-serif;
              font-size: 12px;
              color: #555;
              margin: 2px 0;

              strong {
                font-weight: 600;
              }
            }
          }
        }

        .tab-content-details-options {
          display: flex;
          align-items: center;
          margin-left: auto;
          padding-left: 15px;
        }
      }

      .tab-content-details-body {
        padding: 0;
        background: #fafafa;
        border-radius: 10px;
        flex-grow: 1;
        display: flex;
        position: relative;

        iframe {
          width: 100%;
          height: 100%;
          border: none;
        }
      }

      .tab-content-attachments {
        padding: 15px;
        background: #f0f0f0;
        border-radius: 8px;
        margin-top: 15px;

        h4 {
          font-family: "Nunito", sans-serif;
          font-size: 14px;
          font-weight: 600;
          color: #333;
          margin: 0 0 10px 0;
        }

        ul {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            font-family: "Nunito", sans-serif;
            font-size: 13px;
            color: #444;
            padding: 5px 0;
            border-bottom: 1px dashed #ddd;

            &:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }

    .widget-notfound {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      background: #ffffff;
      border-radius: 5px;
    }
  }
}
</style>